import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useCatalogItemIsResponded, useCatalogItemIsViewed } from '@cp/entities/client';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { ICatalogItem } from 'src/entities/catalog';
import { HotBadge, VacancyCard } from 'src/entities/vacancy';
import { catalogItemConnectToIntent } from 'src/features/catalogItem';
import { getVacancyCardAppearanceSx, shouldDisableVacancyCardInfo } from '../lib';
import { ResponseButton } from './responseButton';
import { ConnectButton } from './connectButton';

const HOT_BADGE_INSET_SX = { mt: { xs: '-6px', md: 0 }, mr: { xs: '-6px', md: 0 } } as const;

export const VacancyCardWidget = ({ url, ...props }: ICatalogItem) => {
  const theme = useTheme();
  const isLoggedIn = useIsLoggedIn();
  const isViewed = useCatalogItemIsViewed(props.data.id);
  const isResponded = useCatalogItemIsResponded(props.data.id);
  const isRealVacancy = props.data.fake === false;
  const isHighlighted = isRealVacancy && !isViewed && !isResponded;

  const handleTitleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!isLoggedIn) {
      e.stopPropagation();
    }
    if (isLoggedIn) {
      e.preventDefault();
    }
  };

  return (
    <VacancyCard
      disableInfo={shouldDisableVacancyCardInfo(isLoggedIn, props.data.fake)}
      footer={
        <Box onClick={(e) => e.stopPropagation()} sx={{ display: 'flex', gap: 1, flex: '1 0 auto', justifyContent: 'end' }}>
          <ResponseButton catalogItemId={props.data.id} color="pink" size="extraSmall" variant="secondary">
            Я могу
          </ResponseButton>
          <ConnectButton
            catalogItemId={props.data.id}
            color="gray ultra light"
            data-intent={catalogItemConnectToIntent(props.data.id)}
            size="extraSmall"
            variant="secondary"
          >
            Задать вопрос
          </ConnectButton>
        </Box>
      }
      hotBadge={isRealVacancy ? <HotBadge sx={HOT_BADGE_INSET_SX} /> : undefined}
      onTitleClick={handleTitleClick}
      replied={isResponded}
      sx={getVacancyCardAppearanceSx(theme, { highlighted: isHighlighted, viewed: isViewed, replied: isResponded })}
      url={url ? String(url) : undefined}
      viewed={isViewed}
      {...props}
    />
  );
};
